/**
 * Общата мярка на двете колони в „Закрий" с бакшиш: банкнотите на рестото и
 * методите вдясно са с еднаква височина, заобляне и разстояние, а заглавието
 * над методите е като „Общо за плащане:" вляво (`AmountFigure`). Без бакшиш
 * модалът е старият (методите — по своя `py-4`, заглавието — `CLOSE_COLUMN_LABEL`).
 */
export const CLOSE_BOX_HEIGHT = "h-14";
export const CLOSE_BOX_RADIUS = "rounded-xl";
/** Разстоянието между редовете — като между методите вдясно. */
export const CLOSE_ROW_GAP = "gap-2.5";
/** Полето за сума в „Закрий" с бакшиш (бакшишът, рестото, „Смесено"): широко — 54px; на
 *  телефон — точно колкото методите там (`rounded-[10px] px-3 py-2.5` → 43px), без клавиатура. */
export const CLOSE_FIELD_BOX = "h-[54px] rounded-xl pl-4 pr-[9px]";
export const CLOSE_PHONE_FIELD_BOX = "h-[43px] rounded-[10px] px-3";
/** Размерът на реда на метода вдясно (`CloseMethodRow`) — и на „Плащане с
 *  депозит" над тях, за да са еднакви кутийки: с бакшиш — `CLOSE_BOX_HEIGHT`,
 *  без него — старият `py-4`, на телефон — по-ниският. */
export const closeMethodRowSize = (isNarrow: boolean, boxed: boolean) =>
  isNarrow
    ? "rounded-[10px] px-3 py-2.5"
    : boxed
      ? `rounded-xl px-4 ${CLOSE_BOX_HEIGHT}`
      : "rounded-xl px-4 py-4";
/** „Изберете метод:" в стария модал (без бакшиш). */
export const CLOSE_COLUMN_LABEL =
  "mb-1.5 text-[10.5px] font-bold uppercase tracking-[1.2px] text-pos-muted";
/** „Изберете метод:" с бакшиш — като „Общо за плащане:" (`AmountFigure`): размерът е от изгледа. */
export const CLOSE_COLUMN_TITLE = "mb-2 font-bold leading-[17px] text-pos-ink";
